'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDonutLarge = function MdDonutLarge(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 31.6c5-0.7 9.3-5 10-10h5c-0.7 8.4-6.6 14.3-15 15v-5z m10-13.2c-0.7-5-5-9.3-10-10v-5c8.4 0.7 14.3 6.6 15 15h-5z m-13.2-10c-5 0.8-10 5.7-10 11.6s5 10.8 10 11.6v5c-8.4-0.8-15-7.9-15-16.6s6.6-15.8 15-16.6v5z' })
        )
    );
};

exports.default = MdDonutLarge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/donut-large.js
// module id = 2261
// module chunks = 0